import { checkAuth } from '../../../actions/google/methods/check-auth'
import { useAssetStore } from '@/stores/asset'

/**
 * Checks if Google integration is connected for the current asset
 * @returns {Promise<boolean>} Connection status
 */
export const checkGoogleConnection = async () => {
  const assetStore = useAssetStore()
  
  try {
    const response = await checkAuth(assetStore.assetId)
    return response.isConnected === true
  } catch (error) {
    return false
  }
}
